export function isValueInEnum<E extends Object>(Enum: E, enumValue: any): boolean {
  return (Object.values(Enum) as string[]).includes(enumValue);
}
